export default __webpack_public_path__ + "static/block-malicious-domains-85abb8da3d32d0937ff40290926c9f9d.png";